import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  Drawer,
  Stack,
  Typography,
} from "@mui/material";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { ErrorSnackbar } from "../Common/CustomSnackbar";
import { colors } from "../../theme/theme";
import axiosInstance from "../../utils/config/config";
import { SecondaryBtn } from "../Common/CustomBtn";

const StripeModal = ({
  open,
  onClose,
  customerId,
  onSubscriptionCreated,
  plan,
}) => {
  const stripe = useStripe();
  const elements = useElements();

  const [savedCards, setSavedCards] = useState([]);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [addingNew, setAddingNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState({ error: false, message: "" });

  useEffect(() => {
    if (open) {
      fetchSavedCards();
    }
  }, [open]);

  const fetchSavedCards = async () => {
    try {
      const { data } = await axiosInstance.get(`/payments/getUserInfo`);
      const cards = data.paymentMethods || [];
      setSavedCards(cards);
      setAddingNew(cards.length === 0);
    } catch (err) {
      setErrorState({ error: true, message: "Failed to fetch cards." });
    }
  };

  const handleSubmit = async () => {
    setErrorState({ error: false, message: "" });
    if (!stripe || !elements) return;

    setLoading(true);
    try {
      const { data } = await axiosInstance.post(
        "/payments/create-subscription",
        {
          plan,
        }
      );

      if (data.message === "Successfully susbcribed to only hands") {
        onSubscriptionCreated();
        onClose();
      }
    } catch (err) {
      setErrorState({ error: true, message: err.message || "Payment failed." });
    } finally {
      setLoading(false);
    }
  };

  const getPlanPrice = () => {
    if (plan === "Basic Plan") return "6%";
    if (plan === "Growth Plan") return "9%";
    return "";
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      sx={{
        "& .MuiDrawer-paper": {
          width: "75%",
          border: "1px solid #000",
          backgroundColor: "#fff",
        },
      }}
      onClose={onClose}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />

      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 4,
            py: 2,
            borderBottom: "1px solid #000",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "23px",
                fontFamily: "Inter-SemiBold",
                color: colors.textColor,
              }}
            >
              Subscribing to {plan}
            </Typography>
            <Typography sx={{ fontSize: "18px", color: "#555" }}>
              Percentage: {getPlanPrice()}
            </Typography>
          </Box>

          <Stack direction="row" spacing={2}>
            <SecondaryBtn onClick={onClose} text="Close" noIcon width="100px" />
            <SecondaryBtn
              onClick={handleSubmit}
              text="Confirm"
              noIcon
              width="120px"
              filled
              disabled={
                !stripe || (savedCards.length && !selectedCardId && !addingNew)
              }
            />
          </Stack>
        </Box>

        {/* <Box sx={{ p: 4 }}>
          {!addingNew && savedCards.length > 0 && (
            <Stack spacing={2} mb={3}>
              {savedCards.map((card) => (
                <Box
                  key={card.id}
                  onClick={() => setSelectedCardId(card.id)}
                  sx={{
                    border:
                      selectedCardId === card.id
                        ? "2px solid #FC0108"
                        : "1px solid #ccc",
                    borderRadius: 2,
                    p: 2,
                    cursor: "pointer",
                    backgroundColor:
                      selectedCardId === card.id ? "#FFF5F5" : "#fff",
                    transition: "all 0.3s ease",
                  }}
                >
                  <Typography sx={{ fontWeight: 600 }}>
                    **** **** **** {card.card.last4}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", color: "#666" }}>
                    {card.card.brand} — Exp {card.card.exp_month}/
                    {card.card.exp_year}
                  </Typography>
                </Box>
              ))}
              <SecondaryBtn
                text="+ Add New Card"
                width="200px"
                noIcon
                onClick={() => {
                  setAddingNew(true);
                  setSelectedCardId(null);
                }}
              />
            </Stack>
          )}

          {addingNew && (
            <Box>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Enter your card details
              </Typography>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 2,
                  p: 2,
                  maxWidth: 500,
                }}
              >
                <CardElement options={{ hidePostalCode: true }} />
              </Box>
              {savedCards.length > 0 && (
                <SecondaryBtn
                  text="Back to Saved Cards"
                  width="200px"
                  noIcon
                  sx={{ mt: 2 }}
                  onClick={() => {
                    setAddingNew(false);
                    setSelectedCardId(null);
                  }}
                />
              )}
            </Box>
          )}
        </Box> */}
      </Box>
    </Drawer>
  );
};

export default StripeModal;
